const concatItemNumber = (itemNumber) => {
  return "№" + itemNumber;
};

export default concatItemNumber;